import React, { Component } from "react";
import { Container, Image, Overlay, OverlayTrigger } from "react-bootstrap";
import { Link } from "react-router-dom";
import ProfileIcon from '../../assets/images/profile.png'
import { getAdminUser } from "../../utils/ReusableFunctions";
import MenuIcon from "../../assets/images/menu.svg";
import Sidebar from "./Sidebar";

export class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openSidebar: false,
    };
  }

  render() {
    const isMobile = window.innerWidth <= 768;
    return (
      <div className="nav-component">
        { this.state.openSidebar &&
          <div className="open-sidebar" onClick={()=>this.setState({openSidebar:false})}>
            <Sidebar/>
          </div>
        }
        <div className="">
        </div>
        {/* <Container> */}

        <div className="nav-wrapper d-flex justify-content-between gap-12 align-items-center">

          {isMobile ? <img onClick={()=>this.setState({openSidebar:!this.state.openSidebar})} src={MenuIcon} width={24} alt="Logo" /> : <div></div>}
          <OverlayTrigger
            trigger={"click"}
            placement="bottom"
            overlay={
              <div className="profile-dropdown p-3">
                {getAdminUser() && 
                <div className="profile-info mb-3">
                  <h4 className="f-s-12 mb-1">{getAdminUser()?.name || "Admin User"}</h4>
                  <p className="f-s-12 mb-0 fade-text">{getAdminUser()?.emailAddress || "admin@example.com"}</p>
                </div>
                }
                <hr />
                <Link to="/change-password" className="d-block mb-2 black f-s-16">Change Password</Link>
                <Link to={"#"}  className="d-block mb-2 black f-s-16" onClick={
                  () => {
                    localStorage.removeItem("finAdmin");
                    window.location.href = "/";
                  }
                }>Logout</Link>
              </div>
            }
            rootClose
          >
            <div className="d-flex align-items-center">
              <h3 className="inter-medium f-s-16 lh-21 black mr-3"><Image src={ProfileIcon} className="w-100" /> </h3>
              <div className="text-left">
              <h5 className="f-s-16 pointer">{getAdminUser()?.name || "User"}{dropIcon} </h5>
              <h5 className="f-s-14 fade-text pointer">{getAdminUser()?.role?.roleName || "Admin"} </h5>
              </div>
            </div>
          </OverlayTrigger>
        </div>
        {/* </Container> */}
      </div>
    );
  }
}

export default Navbar;


export const dropIcon = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 10.2666L4 6.26659L4.93333 5.33325L8 8.39992L11.0667 5.33325L12 6.26659L8 10.2666Z" fill="black" />
</svg>
